export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./scratch.vue?vue&type=template&id=0b32c18a&"


//////////////////
// WEBPACK FOOTER
// ./src/views/scratch/scratch.vue?vue&type=template&id=0b32c18a&
// module id = null
// module chunks = 